var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('h2', {
    staticClass: "text-center text-primary"
  }, [_vm._v(_vm._s(_vm.textoDaSolicitacaoDeAcesso))]), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarSolicitacoesDeAcesso.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "id": "cpf",
      "label": "CPF",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "14"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarSolicitacoesDeAcesso.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "cpf", $$v);
      },
      expression: "form.filters.cpf"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Situação",
      "items": _vm.form.lists.listSituacoes,
      "item-text": 'descricao',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "lotacao",
      "label": "Lotação",
      "items": _vm.form.lists.listLotacao,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.lotacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "lotacao", $$v);
      },
      expression: "form.filters.lotacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "funcao",
      "label": "Função",
      "items": _vm.form.lists.listFuncoes,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.funcao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "funcao", $$v);
      },
      expression: "form.filters.funcao"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarSolicitacoesDeAcesso();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listSolicitacoesDeAcesso,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": "Não há registros a serem exibidos"
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.cpf`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.cpf) + " ")];
      }
    }, {
      key: `item.lotacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.lotacao) + " ")];
      }
    }, {
      key: `item.funcao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.funcao) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.situacao) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [item.situacao != 'Pendente de aprovação' ? _c('sca-tooltip', {
          attrs: {
            "icon": 'mdi-pencil',
            "text": 'Editar parecer',
            "small": true,
            "color": 'primary'
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterSolicitacoesDeAcesso(item, false);
            }
          }
        }) : _vm._e(), item.situacao == 'Pendente de aprovação' ? _c('sca-tooltip', {
          attrs: {
            "icon": 'mdi-file-find',
            "text": 'Realizar parecer',
            "small": true,
            "color": 'green'
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterSolicitacoesDeAcesso(item, true);
            }
          }
        }) : _vm._e(), item.situacao != 'Pendente de aprovação' ? _c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar parecer ',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarSolicitacoesDeAcesso(item);
            }
          }
        }) : _vm._e(), item.situacao != 'Pendente de aprovação' ? _c('sca-tooltip', {
          attrs: {
            "text": 'Enviar e-mail',
            "icon": 'mdi-email',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.enviarEmailSolicitacoesDeAcesso(item);
            }
          }
        }) : _vm._e()];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarSolicitacaoAcessoDialog', {
    attrs: {
      "visible": _vm.dialogManterSolicitacoesDeAcesso.visible,
      "content": _vm.dialogManterSolicitacoesDeAcesso.content,
      "edit": _vm.dialogManterSolicitacoesDeAcesso.edit,
      "primeiroEnvio": _vm.primeiroEnvio
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterSolicitacoesDeAcesso.close();
      },
      "onSave": function ($event) {
        return _vm.buscarSolicitacoesDeAcesso();
      }
    }
  }), _c('VisualizarSolicitacaoAcessoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarSolicitacoesDeAcesso.visible,
      "content": _vm.dialogVisualizarSolicitacoesDeAcesso.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarSolicitacoesDeAcesso.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }